import { useState, useEffect } from 'react';
import {Navigate } from 'react-router-dom';
import Master from './../components/_layouts/admin/Master';
import axios from 'axios';
import swal from 'sweetalert'; 

function AdminPrivateRoute() {
  const [authenticated, setAuthenticated] = useState(null);

  useEffect(() => {
    axios.get('/api/checkingAuthenticated')
      .then(res => {
        if (res.data.status === 200) {
          // Check if the authenticated user has the Admin role (role_as === 1)
          if (res.data.role_as === 1) { 
            setAuthenticated(true);
          } else {
            // Logged in, but not an Admin
            setAuthenticated(false);
            swal("Access Denied", "You are not authorized to view the admin area.", "warning");
          }
        } else {
          setAuthenticated(false);
        }
      })
      .catch(error => {
        // Unauthenticated or Server Error
        setAuthenticated(false);
          // Optional: Clear token if 401/403 (handled better in Main.js interceptor)
      });
  }, []);

  if (authenticated === null) return <div>Loading...</div>;

  // If not authenticated, navigate to login
  return authenticated ? <Master /> : <Navigate to="/login" />;
}
export default AdminPrivateRoute;